import { useUserStore } from "@/app/providers/user_provider"

export function UserMenuHeader() {
  const { user, isLoggedIn } = useUserStore((store) => store)

  return (
    <header className="mb-2 flex w-full items-center gap-0.5 px-4 text-main-dark">
      <p className="text-base font-semibold">
        {(
          isLoggedIn &&
          user &&
          user.firstName &&
          user.firstName.trim().length !== 0
        ) ?
          `Hi, ${user.firstName}!`
        : "Hi!"}
      </p>
    </header>
  )
}
